export default "__VITE_ASSET__BV0hW4AJ__"